// Consent Mode v2 wiring for the GTM container (GTM-WLVGB8F8).
// GTM defaults every consent type to 'denied'; we flip them to 'granted'
// once the user accepts. There is no separate analytics/marketing split in
// this app, so a single accept grants all types.

const GRANTED = {
  ad_storage: 'granted',
  ad_user_data: 'granted',
  ad_personalization: 'granted',
  analytics_storage: 'granted',
};

export const grantConsent = () => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('consent', 'update', GRANTED);
  }
};

// Re-apply stored consent on app load so returning visitors are tracked
// (GTM otherwise starts every session at the denied default).
export const applyStoredConsent = () => {
  try {
    if (window.localStorage.getItem('consent')) {
      grantConsent();
    }
  } catch (e) {
    /* localStorage unavailable */
  }
};
